'use strict';
/*
  By default Angular hides an input value if ng-pattern is used and the initial model value is invalid.
  Since that is not usable we need to apply a workaround to always show the initial value and simply mark as invalid if it is.
 */
angular.module('clientDashboardApp').directive('input', function() {
  return {
    require: '?ngModel',
    restrict: 'E',
    link: function($scope, $element, $attrs, ngModelController) {
      var inputType = angular.lowercase($attrs.type);

      if (!ngModelController || inputType === 'radio' ||
        inputType === 'checkbox') {
        return;
      }

      ngModelController.$formatters.unshift(function(value) {
        if (ngModelController.$invalid && angular.isUndefined(value)
          && typeof ngModelController.$modelValue === 'string') {
          return ngModelController.$modelValue;
        } else {
          return value;
        }
      });
    }
  };
});
